import type { PageItemGateProps } from "./page-item-gate.type";

import { Navigate } from "react-router";

import { getModelRoute } from "@/modules/model";
import { PageError } from "@/modules/page-error";
import { isError404 } from "@/services/api";
import { useIdParam } from "@/services/router";

export const PageItemGate = ({
  model,
  queryError,
  children,
}: PageItemGateProps) => {
  const idParam = useIdParam();

  if (!idParam || isError404(queryError)) {
    const listRoute = getModelRoute(model, "list");
    return <Navigate to={listRoute} replace />;
  }

  if (queryError) {
    return <PageError status={500} />;
  }

  return children;
};
